module.exports = require("@gauzy/plugin-changelog");